import { Organisation } from "../organisation/OrganisationModelV2"
import { ACLModel } from "./ACLModel"
import { Person } from "./Person"

export class ProfileModel {
    person: Person
    acl?: ACLModel
    organisations?: Organisation[]
    /** type of every organisation on the profile, not just the mills kept above */
    organisationTypes: string[]
    roles: string[]

    constructor(data: any) {
        this.acl = data.acl
        this.organisations = data.organisation
        this.person = data.person
        this.organisationTypes = data.organisationTypes ?? []
        this.roles = data.roles ?? []
    }

    toJson() {
        return JSON.parse(JSON.stringify(this))
    }

    avatarUrl() {
        return this.person.user?.avatar_url
    }

    avatarUri() {
        return this.person.user?.avatar_uri ?? this.person.avatar_uri
    }

    isSaranaUser(): boolean {
        return this.roles.includes('operator')
    }

    isAppUser(): boolean {
        return this.roles.includes('user')
    }

    isFieldAgent(): boolean {
        return this.roles.includes('fieldagent')
    }

    isUserMill(): boolean {
        return this.roles.includes('usermill')
    }

    hasMill(): boolean {
        return this.organisationTypes.includes('mill')
    }

    hasConglomerate(): boolean {
        return this.organisationTypes.includes('conglomerate')
    }


    static fromJson(data: any) {
        return new ProfileModel({
            person: Person.build(data.person),
            acl: ACLModel.build(data.acl),
            organisation: data.organisations?.map(o => Organisation.build(o)),
            organisationTypes: data.organisationTypes,
            roles: data.roles
        })
    }

    static build(data: any): ProfileModel {
        return new ProfileModel({
            person: Person.build(data.person),
            acl: ACLModel.build(data.acl),
            organisation: data.organisations?.filter(o => o.type === "mill")?.map(o => Organisation.build(o)),
            organisationTypes: data.organisations?.map((o: any) => o.type),
            roles: data.auth_role?.map((r: any) => r.role)
        })
    }
}